module.exports = __webpack_public_path__ + "img/vendlet01.60af0d34.jpeg";